// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__CsPvU","placeHolderShimmer":"Report_placeHolderShimmer__hc-x4"};